import { render, staticRenderFns } from "./DataOverlay.vue?vue&type=template&id=580588be&scoped=true"
import script from "./DataOverlay.vue?vue&type=script&lang=js"
export * from "./DataOverlay.vue?vue&type=script&lang=js"
import style0 from "./DataOverlay.vue?vue&type=style&index=0&id=580588be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580588be",
  null
  
)

export default component.exports